<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-6">
          <img src="../../../assets/images/wasyyah_logo.jpeg" alt="">
          <h2>Registration</h2>
          <p>Enter your details to register <strong>Al Wasyyah</strong></p>
        </div>
        <div class="col-6">
          <form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <b-form-input type="text" v-model="formData.first_name" class="form-control" name="first_name" placeholder="First Name" required></b-form-input>
                </div>
                <div class="form-group">
                  <b-form-input type="text" v-model="formData.last_name" name="last_name" placeholder="Last Name" required></b-form-input>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <b-form-input type="number" v-model="formData.mobile" name="mobile" placeholder="Phone Number" required></b-form-input>
                </div>
                <div class="form-group">
                  <b-form-input type="text" v-model="formData.email" name="email" placeholder="Email" required></b-form-input>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <b-form-datepicker id="example-datepicker" v-model="formData.date_of_birth" class="mb-2"></b-form-datepicker>
                </div>
                <div class="form-group">
                  <b-form-input type="text" v-model="formData.email" name="email" placeholder="Email" required></b-form-input>
                </div>
              </div>
              <div class="form-group">
                <v-select
                    v-model="formData.security_question"
                    :options="options"
                    placeholder="Select security question"
                    required
                ></v-select>
              </div>
              <div class="input-group">
                <input type="text" id="security_answer" name="security_answer" placeholder="Write your answer here" required>
              </div>
              <div class="input-group">
                <label for="password">Password <span class="required">*</span></label>
                <input type="password" v-model="formData.password" name="Password" id="password">
              </div>
              <div class="input-group">
                <label for="password">Conform Password <span class="required">*</span></label>
                <input type="password" v-model="formData.conf_password" name="Password" id="password">
              </div>

              <div class="input-group">
                <input type="submit" value="Submit">
                <input type="reset" value="reset">
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// import apiRepository from "@/services/apiRepository";
import Vue3Select from "vue3-select";
import "vue3-select/dist/vue3-select.css";
import axios from "axios";

export default {
  components: {"v-select": Vue3Select},
  name: 'SignUp',
  data() {
    return {
      formData: {
        first_name: '',
        last_name: '',
        security_question: '',
        mobile: '',
        email: '',
        password: '',
        conf_password: '',
        date_of_birth: ''
      },
      options: [
        {text: "What is your mother's maiden name?", value: '1'},
        {text: "What was the name of your first pet?", value: '2'},
        {text: "Who was your favorite teacher?", value: '3'}
      ]
    };
  },
  methods: {
    async onSubmit() {
      axios.get('http://localhost:3000/userSignUp')
          .then(response => {
            this.users = response.data;
            const user = this.users.find(user => user.email === this.formData.email && user.password === this.formData.password);
            if (user) {
              alert('Login successful! Redirecting to home page...');
              localStorage.setItem('auth', true);  // Save the auth token
              this.$router.push('/login');
            } else {
              alert('Invalid email or password. Please try again.');
            }
          })
          .catch(error => {
            console.error('Error fetching users:', error);
            alert('An error occurred while trying to log in. Please try again later.');
          });
    },
  }
}
</script>

<style scoped>

</style>